export const isAuthenticated = (state) => {
    console.log('jabba',state)
    if (state.auth.auth.token) return true;
    return false;
};
